// Export interfaces.
export { default as IEngagementExtraData } from './IEngagementExtraData';
export { default as IDefaultRecipients } from './IDefaultRecipients';
export {
    IGetSharingInformationResponse, IPermissionsInformation, ISharingLinkFromAPI,
    ISharingPrincipalFromAPI, ISharingLinkAbilities, ISharingLinkAbilityStatus,
    ISharingLinkAbilitiesMatrix, ISharingInformation, ISharingItemInformation,
    ISharingLinkV3 as ISharingLink, ISharingPrincipal,
    ISharingContext, IShareLinkContext, IUnshareLinkContext,
    IShareResult, IUpdatePermissionsResponse, IRecipient,
    ISharingContextInformation, IShareLinkResult, ICustomLabeledAudienceConfig,
    ISharingLinkTemplate, SharingAudienceTemplates
} from '@ms/odsp-datasources/lib/interfaces/sharing/SharingInterfaces';
export { default as IPolicyTipInformation } from './IPolicyTipInformation';
export { default as ISharingLinkSettings } from './ISharingLinkSettings';
export { default as ISharingStore, IShareLinkParams } from './ISharingStore';

// Export enums.
export { default as AccessStatus } from './enums/AccessStatus';
export {
    Error, Category, UpdatePermissionsRole,
    SharePermission, SharingAudience, SharingLinkKind,
    SharingRoleV3 as SharingRole, Mode, ClientId
} from '@ms/odsp-datasources/lib/interfaces/sharing/SharingInterfaces';
export { default as FileShareType } from './enums/FileShareType';
export { default as OutlookAvailability } from './enums/OutlookAvailability';
export { default as PrincipalType } from '@ms/odsp-datasources/lib/dataSources/roleAssignments/PrincipalType';
export { default as ShareType } from './enums/ShareType';
export { default as SharingCapabilityDisabledReason } from './enums/SharingCapabilityDisabledReason';
